import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CourseTask } from '@core/models/course/course-task.model';
import { FormQuestion } from '@core/models/form-question';
import { environment } from '@env';
import { Observable } from 'rxjs';
import { TaskModel } from '../models/course/task-model';
import { formatDate } from '@angular/common';
import { adaptTimeForAPI } from '@shared/constants/time-adapt-function';


@Injectable({
  providedIn: 'root'
})
export class TaskApiService {
  readonly resourceUrl = environment.apiUrl+ '/me/tasks';
  constructor( protected http: HttpClient){}

  list(seriesId:string){
    return this.http.get(this.resourceUrl+"/getTasksForSeries/"+seriesId);
  }

  get(id:string): Observable<TaskModel>{
    return this.http.get<TaskModel>(this.resourceUrl+"/"+id);
  }

  getGlobal(id:string): Observable<TaskModel>{
    return this.http.get<TaskModel>(this.resourceUrl+"/global/"+id);
  }

  uploadTask(id:string, file: File): Observable<any> {
    var formData: any = new FormData();
      formData.append('task', id);
      formData.append('file', file);
      return this.http.post(this.resourceUrl+'/uploadTask', formData, {
          reportProgress: true,
          observe: 'events',
        });
  }

  getQuestionFeedback(questionId: string, answers: string|string[]): Observable<{correctAnswers: string[], feedback: string}> {
    const data = { question: questionId, answers };
    return this.http.post<any>(this.resourceUrl+'/getQuestionFeedback', data);
  }

  getFeedbackSummary(taskId: string): Observable<any> {
    return this.http.get<any>(this.resourceUrl+'/getFeedbackSummary?task='+taskId);
  }

  turnIn(task: CourseTask, questions: FormQuestion[], started:Date): Observable<any> {
    const isAdmin = localStorage.getItem('admin_block') ?? "false";
    const data = {
      task: task.id,
      started: adaptTimeForAPI(started),
      questions: questions.map(q => {
        return {
          question: q.id,
          answers: q.answer
        };
      }),
      admin: (isAdmin =="true")
    };

    return this.http.post<any>(this.resourceUrl+'/turnIn', data);
  }
}
